/* eslint-disable react/no-did-mount-set-state */
import React from 'react';
import { Container } from 'reactstrap';
import { Redirect } from 'react-router-dom';

import AppComponent from './AppComponent';

import AdriftGif from '../../img/adrift.gif';

class Adrift extends AppComponent {
  render() {
    if (this.app.user.facilities.length > 0) {
      return (<Redirect to="/login" />);
    }

    return (
      <Container fluid id="main-container" className="text-center">
        <img className="" src={AdriftGif} style={{ width: '500px', alignSelf: 'center' }} alt="Waiting for an invitation" />
        <h2 className="mb-lg-3">Waiting for an invitation?</h2>
        <p>
          It looks like you do not belong to a facility yet. Please
          <br />
          wait for or request an invite from your administrator.
        </p>
      </Container>
    );
  }
}

export default Adrift;



// WEBPACK FOOTER //
// ./src/components/core/Adrift.js